// ==================== COMPLETE MODERN MAIN LAYOUT ====================
// src/components/layout/MainLayout.js

import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme as useMuiTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useTheme } from '../../contexts/ThemeContext';

const SIDEBAR_WIDTH = 280;
const SIDEBAR_COLLAPSED_WIDTH = 70;
const HEADER_HEIGHT = 64;

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { isDarkMode } = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        background: isDarkMode
          ? 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)'
          : 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      }}
    >
      {/* Sidebar - Fixed positioning */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          width: isMobile
            ? 0
            : sidebarOpen
              ? SIDEBAR_WIDTH
              : SIDEBAR_COLLAPSED_WIDTH,
          zIndex: 1200,
          transition: 'width 0.3s ease-in-out',
        }}
      >
        <Sidebar
          open={sidebarOpen}
          onToggle={handleSidebarToggle}
          width={SIDEBAR_WIDTH}
          collapsedWidth={SIDEBAR_COLLAPSED_WIDTH}
          isMobile={isMobile}
        />
      </Box>

      {/* Main Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: isMobile
            ? 0
            : sidebarOpen
              ? `${SIDEBAR_WIDTH}px`
              : `${SIDEBAR_COLLAPSED_WIDTH}px`,
          transition: 'margin-left 0.3s ease-in-out',
          minHeight: '100vh',
        }}
      >
        {/* Header - Fixed positioning */}
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            right: 0,
            left: isMobile
              ? 0
              : sidebarOpen
                ? SIDEBAR_WIDTH
                : SIDEBAR_COLLAPSED_WIDTH,
            zIndex: 1100,
            transition: 'left 0.3s ease-in-out',
          }}
        >
          <Header
            onSidebarToggle={handleSidebarToggle}
            height={HEADER_HEIGHT}
          />
        </Box>

        {/* Page Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            padding: 3,
            paddingTop: `${HEADER_HEIGHT + 24}px`,
            minHeight: '100vh',
            background: 'transparent',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
